/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaAnchorViewProps } from './citta-anchor';

export default (props: ICittaAnchorViewProps) => {
    const { Anchor } = props;
    return (
        <Node {...Anchor} />
    );
};
